import type { ComponentProps, FunctionComponent } from 'react';
import React from 'react';
import { Tooltip } from '@trello/nachos/tooltip';
import styles from './ShortcutTooltip.less';
import classNames from 'classnames';

interface ShortcutTooltipProps
  extends Omit<ComponentProps<typeof Tooltip>, 'content'> {
  shortcutText: string;
  shortcutKey: string;
  // Some screen readers won't read symbols ("[", "`", "?", etc), so this prop can be used
  // to provide a description of the key to announce instead
  shortcutKeyDescription?: string;
}

export const ShortcutTooltip: FunctionComponent<ShortcutTooltipProps> = ({
  children,
  shortcutText,
  shortcutKey,
  shortcutKeyDescription,
  ...rest
}) => (
  <Tooltip
    content={
      <div className={styles.tooltip}>
        {shortcutText}
        <span
          aria-label={shortcutKeyDescription}
          className={classNames(styles.tooltipShortcut)}
        >
          {shortcutKey}
        </span>
      </div>
    }
    hideTooltipOnClick
    {...rest}
  >
    {children}
  </Tooltip>
);
